<app-base-modal
  [title]="getTitle()"
>
  <form
    class="form"
    [formGroup]="attachAllFormGroup"
  >
    @for (field of attachAllFormFields; track $index) {
      @switch (field.type) {
        @case ('select') {
          <mat-form-field appearance="outline">
            <mat-label>{{ field.label }}</mat-label>
            <mat-select
              [formControlName]="field.fieldName"
            >
              <mat-option></mat-option>
              @for (option of forcesSelectData; track $index) {
                <mat-option [value]="option.value">
                  {{ option.displayValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @case ('date') {
          <mat-form-field
            appearance="outline"
            class="date"
          >
            <mat-label>{{field.label}}</mat-label>
            <input
              matInput
              appDateInput
              [matDatepicker]="picker"
              [formControlName]="field.fieldName"
              (dateChange)="isDateValid(picker, field.fieldName)"
              placeholder="ДД.ММ.ГГГГ"
            >
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            >
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        }
      }
    }
  </form>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="attachAllFormGroup.invalid"
      (click)="handleAttachAll()"
    >
      Привязать
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отменить
    </button>
  </div>
</app-base-modal>
